@if (
  {
    row: columnData | async,
  };
  as $
) {
  @if ($.row) {
    <span class="cursor-pointer" (click)="executeAction('edit', $.row)">{{
      getTrialType($.row)
    }}</span>
  }
}
